import { apiRoutes } from "@portal/constants/routes";
import { GAEventName } from "./ga-event-name.enum";
import { DataLayerEvent } from "./types";
import runInBackground from "@portal/shared/utils/runInBackground";
import { fetcher } from "@portal/shared/utils/fetcher";
import { Ecommerce } from "./events/ecommerce";

export const ALLOWED_TIKTOK_EVENTS: ReadonlySet<GAEventName> = new Set([
  GAEventName.ADD_TO_CART,
  GAEventName.VIEW_CONTENT,
  GAEventName.SCROLL_DEPTH,
  GAEventName.TIME_SPENT,
]);

export const logTikTokEvent = (event: DataLayerEvent) => {
  const eventName = event.event || event.event_name;
  const store = event.store;
  const eventEcommerce = event.ecommerce as Ecommerce;
  const items = eventEcommerce?.items;
  if (!eventName || !store) return;

  if (ALLOWED_TIKTOK_EVENTS.has(eventName as GAEventName)) {

    if (eventName === GAEventName.ADD_TO_CART) {
      runInBackground(
        async () =>
          fetcher.post(apiRoutes.analytics.tikTokAddToCart({ store }), {
            eventId: event.eventId,
            currency: eventEcommerce?.currency,
            value: eventEcommerce?.value ? parseFloat(eventEcommerce?.value) : 0.0,
            items: 
              items &&
              items.map((item) => {
                return {
                  item_id: item.item_id,
                  item_name: item.item_name,
                  item_variant: item.variant_id,
                  variant_id: item.variant_id,
                  price: item.price,
                  quantity: item.quantity,
                };
              }),
            user: {
              email: event.email
            }
          }),
        {
          feature: 'AddToCart'
        }
      );
    }

    if (eventName === GAEventName.VIEW_CONTENT) {
      runInBackground(
        async () =>
          fetcher.post(apiRoutes.analytics.tikTokViewContent({ store }), {
            eventId: event.eventId,
            currency: event.currency,
            content: (event.contents as any[])?.map(item => ({
              item_id: item.id,
              item_name: item.title,
              variant_id: item.variant_id,
              price: item.price,
              quantity: item.quantity,
            })),
            user: {
              email: event.email
            }
          }),
        { feature: 'ViewContent' }
      );      
    }

    if (eventName === GAEventName.SCROLL_DEPTH) {
      runInBackground(
        async () =>
          fetcher.post(apiRoutes.analytics.tikTokScrollDepth({ store }), {
            user: {
              email: event.email
            },
            page: event.page,
            eventId: event.eventId || Date.now().toString()
          }),
        { feature: 'ScrollDepth' }
      );      
    }

    if (eventName === GAEventName.TIME_SPENT) {
      runInBackground(
        async () =>
          fetcher.post(apiRoutes.analytics.tikTokTimeSpent({ store }), {
            user: {
              email: event.email
            },
            eventId: event.eventId || Date.now().toString()
          }),
        { feature: 'TimeSpent' }
      );      
    }
  }
}